import Am from '@/pages/Am'

import { createBrowserRouter } from 'react-router-dom'
import { Auth } from '@/components/Auth'
import { Authhn } from '@/components/Authhn'

import Mp1 from '@/pages/Atest/Mp1'

import Test from '@/pages/Atest/Test'
import Test1 from '@/pages/Atest/Test1'
import Test2 from '@/pages/Atest/Test2'
import Test3 from '@/pages/Atest/Test3'

import NotFound from '@/pages/NotFound'
import Fbody from '@/pages/Fbody'

import Mcplis from '@/pages/Amb/Mcplis'

import Dkf from '@/pages/Amb/Dkf'
import M2d1 from '@/pages/Amb/M2d1'

import M2d3 from '@/pages/Amb/M2d3'
import M2d4 from '@/pages/Amb/M2d4'
import M2d6 from '@/pages/Amb/M2d6'
import M2d61 from '@/pages/Amb/M2d61'
import M2d62 from '@/pages/Amb/M2d62'
import M2d63 from '@/pages/Amb/M2d63'



import M3c1 from '@/pages/Amb/M3c1'
import M3c2 from '@/pages/Amb/M3c2'
import M3c3 from '@/pages/Amb/M3c3'


import M4z2 from '@/pages/Amb/M4z2'
import M4z3 from '@/pages/Amb/M4z3'



import Hdgtz from '@/pages/Amb/Hdgtz'
import Hfpsc from '@/pages/Amb/Hfpsc'
import Hqqsh from '@/pages/Amb/Hqqsh'
import Hxfsh from '@/pages/Amb/Hxfsh'
import Hyxzj from '@/pages/Amb/Hyxzj'

import Tcardset from '@/pages/Amb/Tcardset'
import Tcardlog from '@/pages/Amb/Tcardlog'
import Tcardd from '@/pages/Amb/Tcardd'



import Abm from '@/pages/Abm'
import Abmhn from '@/pages/Abmhn'
import Aqyjs from '@/pages/Ambhn/Aqyjs'
import Aprodts from '@/pages/Ambhn/Aprodts'
import Aprodtsy from '@/pages/Ambhn/Aprodtsy'
import Dbhf from '@/pages/Ambhn/Dbhf'
import Dbhflist from '@/pages/Ambhn/Dbhflist'
import Dbqq from '@/pages/Ambhn/Dbqq'
import Dba from '@/pages/Ambhn/Dba'
import Dbr from '@/pages/Ambhn/Dbr'
import Dbdel from '@/pages/Ambhn/Dbdel'
import Urz from '@/pages/Ambhn/Urz'
import Usa from '@/pages/Ambhn/Usa'
import Uauthmg from '@/pages/Ambhn/Uauthmg'

import Bcz from '@/pages/Ambhn/Bcz'
import Bxf from '@/pages/Ambhn/Bxf'
import Bsqrz from '@/pages/Ambhn/Bsqrz'
import Bfp from '@/pages/Ambhn/Bfp'

import Aplist from '@/pages/Ambhn/Aplist'
import Apvoid from '@/pages/Ambhn/Apvoid'


import Ahelp from '@/pages/Ahelp'




const router = createBrowserRouter([

    {
        path: '/', element: <Am />, children: [
            { path: '', element: <Fbody /> },
        ]
    },

    {
        path: '/v3', element: <Abm />, children: [
            { path: '', element: <Mcplis /> },
            { path: 'pdt', element: <><Auth /> <M2d3 /></> },
            { path: 'pdt/sup', element: <><Auth /> <M2d3 /></> },
            { path: 'pdt/sup/intro', element: <><Auth /> <M2d1 /></> },
            { path: 'pdt/sup/plist', element: <><Auth /> <M2d3 /></> },
            { path: 'pdt/sup/M2d6', element: <><Auth /> <M2d6 /></> },
            { path: 'pdt/sup/M2d61', element: <><Auth /> <M2d61 /></> },
            { path: 'pdt/sup/M2d62', element: <><Auth /> <M2d62 /></> },
            { path: 'pdt/sup/M2d63', element: <><Auth /> <M2d63 /></> },

            { path: 'td/rz/send', element: <><Auth /> <M2d62 /></> },
            { path: 'td/rz/ret', element: <><Auth /> <M2d62 /></> },
            { path: 'td/jxms', element: <><Auth /> <M2d62 /></> },

            { path: 'pdt/redb', element: <><Auth /> <M2d4 /></> },
            { path: 'pdt/adb', element: <><Auth /> <M2d4 /></> },
            { path: 'uc/un/uname', element: <><Auth /> <M4z2 /></> },
            { path: 'uc/un/usa', element: <><Auth /> <M4z3 /></> },

            { path: 'uc/oai', element: <><Auth /> <M3c1 /></> },
            { path: 'uc/oai/cz', element: <><Auth /> <M3c1 /></> },
            { path: 'uc/oai/xf', element: <><Auth /> <M3c2 /></> },
            { path: 'uc/oai/kp', element: <><Auth /> <M3c3 /></> },

            { path: 'tc/tz', element: <><Auth /><Mp1></Mp1></> },
            { path: 'tc/tp/p1', element: <><Auth /><Test /></> },
            { path: 'tc/tp/p2', element: <><Auth /><Test1 /></> },
            { path: 'tc/tp/p3', element: <><Auth /><Test2 /></> },
            { path: 'tc/lst', element: <><Auth /><Test3 /></> },

            { path: 'tcard/mgmt/setcard', element: <><Auth /><Tcardset /></> },
            { path: 'tcard/mgmt/cardlog', element: <><Auth /><Tcardlog /></> },
            { path: 'tcard/send', element: <><Auth /><Tcardd /></> },


            { path: 'sys', element: <><Auth /><Test3 /></> },
            { path: 'sys/tcset', element: <><Auth /><Test3 /></> },

            { path: 'sys/hngl/dgtz', element: <><Auth /><Hdgtz /></> },
            { path: 'sys/hngl/fpsc', element: <><Auth /><Hfpsc /></> },
            { path: 'sys/hngl/qqsh', element: <><Auth /><Hqqsh /></> },
            { path: 'sys/hngl/xfsh', element: <><Auth /><Hxfsh /></> },
            { path: 'sys/hngl/yxzj', element: <><Auth /><Hyxzj /></> },

        ]
    },
    {
        path: '/hn', element: <Abmhn />, children: [
            { path: '', element: <Apvoid /> },
            { path: 'pdt', element: <><Authhn /> <M2d3 /></> },
            { path: 'pdt/sup', element: <><Authhn /> <M2d3 /></> },

            { path: 'pdt/plist', element: <><Authhn /> <Aplist /></> },
            { path: 'pdt/sup/prodts', element: <><Authhn /> <Aprodts /></> },
            { path: 'pdt/sup/prodtsy', element: <><Authhn /> <Aprodtsy /></> },
            { path: 'pdt/redb', element: <><Authhn /> <Dbr /></> },
            { path: 'pdt/adb', element: <><Authhn /> <Dba /></> },
            { path: 'pdt/dbdel', element: <><Authhn /> <Dbdel /></> },
            { path: 'dbxf', element: <><Authhn /> <Dbhf /></> },
            { path: 'dbxf/dbhf', element: <><Authhn /> <Dbhf /></> },
            { path: 'dbxf/dbhflist', element: <><Authhn /> <Dbhflist /></> },
            { path: 'dbxf/dbqq', element: <><Authhn /> <Dbqq /></> },
            { path: 'uc/un/intro', element: <><Authhn /> <Aqyjs /></> },
            { path: 'uc/un/uname', element: <><Authhn /> <Urz /></> },
            { path: 'uc/un/uasef', element: <><Authhn /> <Urz /></> },
            { path: 'uc/un/uauth', element: <><Authhn /> <Urz /></> },
            { path: 'uc/un/usa', element: <><Authhn /> <Usa /></> },
            { path: 'uc/un/authmg', element: <><Authhn /> <Uauthmg /></> },

            // authmg

            { path: 'uc/oai/cz', element: <><Authhn /> <Bcz /></> },
            { path: 'uc/oai/xf', element: <><Authhn /> <Bxf /></> },
            { path: 'uc/oai/sqrz', element: <><Authhn /> <Bsqrz /></> },
            { path: 'uc/oai/kp', element: <><Authhn /> <Bfp /></> },
            { path: 'uc/aap', element: <><Authhn /> <Urz /></> },





        ]
    }
    ,
    { path: '/help', element: <><Ahelp /> </> },
    { path: '/x', element: <Dkf /> },
    { path: '*', element: <NotFound /> }
])
export default router